import { i18next } from '@frontend/i18n';
import type { StatusBadgeVariants } from '../status-badge';
import type { ActivitySourceType, ActivityType, StatusType } from './types';

export const ACTIVITY_ROW_CLICK_ALLOWED_STATUSES = ['PENDING', 'ACCEPTED', 'MESSAGED', 'CALLED'];

export const activityTypeLabels: Record<ActivityType, string> = {
  REQUESTED: i18next.t('Request', { ns: 'schedule-activity' }),
  SCHEDULED: i18next.t('Scheduled', { ns: 'schedule-activity' }),
  RESCHEDULED: i18next.t('Rescheduled', { ns: 'schedule-activity' }),
  CANCELED: i18next.t('Cancellation', { ns: 'schedule-activity' }),
};

export const activitySourceTypeLabels: Record<ActivitySourceType, string> = {
  AI_VOICE: i18next.t('AI-Added', { ns: 'schedule-activity' }),
  AI_TEXT: i18next.t('AI-Added', { ns: 'schedule-activity' }),
  BOOKING_SITE: i18next.t('Patient Added', { ns: 'schedule-activity' }),
  STAFF_UI: i18next.t('Staff Added', { ns: 'schedule-activity' }),
  WAITLIST: i18next.t('Direct Booked', { ns: 'schedule-activity' }),
  PMS: i18next.t('Office Added', { ns: 'schedule-activity' }),
  OTHER: i18next.t('Other', { ns: 'schedule-activity' }),
};

export const statusTypeBadgeVariants: Record<StatusType, StatusBadgeVariants> = {
  // Request Statuses
  PENDING: 'request-pending',
  ACCEPTED: 'request-accepted',
  REJECTED: 'request-rejected',
  MESSAGED: 'contacted',
  CALLED: 'contacted',
  DISMISSED: 'request-dismissed',
  DONE: 'request-done',
  DELETED: 'request-deleted',
  UNKNOWN_REVIEWED_STATUS: 'request-unknown',
  // Weave Appointment Statuses
  CONFIRMED: 'appointment-confirmed',
  UNCONFIRMED: 'appointment-unconfirmed',
  ATTEMPTED: 'appointment-attempted',
  IN_OFFICE: 'appointment-in-office',
  COMPLETED: 'appointment-completed',
  NO_SHOW: 'appointment-no-show',
  CANCELED: 'appointment-canceled',
  UNKNOWN_EVENT_STATUS: 'appointment-unknown',
};

type ActivitySourceFilterType = 'SELF_ADDED' | 'AI_ADDED' | 'OFFICE_ADDED';

export const activitySourceFilterOptions: Record<ActivitySourceFilterType, string> = {
  SELF_ADDED: i18next.t('Self Added', { ns: 'schedule-activity' }),
  AI_ADDED: i18next.t('AI Receptionist', { ns: 'schedule-activity' }),
  OFFICE_ADDED: i18next.t('Office Added', { ns: 'schedule-activity' }),
};

export const activitySourceFilterToTypes: Record<ActivitySourceFilterType, ActivitySourceType[]> = {
  SELF_ADDED: ['BOOKING_SITE', 'WAITLIST'],
  AI_ADDED: ['AI_VOICE', 'AI_TEXT'],
  OFFICE_ADDED: ['STAFF_UI', 'PMS', 'OTHER'],
};
